import React from "react";
import { InputAdornment, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Header from "@shared/header";
import { MdOutlinePhoneSVG } from "@shared/MdOutlinePhoneSVG";
import Banner from "./banner";
import Footer from "./footer";
import { Container, Main } from "./requestOTP.styles";

function RequestOTP() {
  const info = useSelector((state: any) => state.info.allData);
  const { t } = useTranslation();

  return (
    <Container>
      {/* <Header logoSize="large" color={"#E7F0F8"} showIndicator /> */}
      <Banner />
      <Main>
        <Typography component='span' fontSize={16}>
          {t("send_sms_info", {
            defaultValue: "We will send a SMS to verify your mobile number.",
          })}
        </Typography>
        <TextField
          disabled
          fullWidth
          value={info?.mobileNumber}
          slotProps={{
            input: {
              name: "phone",
              startAdornment: (
                <InputAdornment position="start">
                  <MdOutlinePhoneSVG />
                </InputAdornment>
              ),
            },
          }}
        />
      </Main>
      <Footer />
    </Container>
  );
}

export default RequestOTP;
